import React from 'react';
import { useCourseStore } from '../courseStore';

interface IParagrap {
  header: string;
  title: string;
  id: string;
  state: 'not-start' | 'in-progress' | 'completed';
}

interface IParagraphsProps {
  paragraphs: IParagrap[];
}

const Paragraphs: React.FunctionComponent<IParagraphsProps> = ({
  paragraphs,
}) => {
  const { activeParagraph } = useCourseStore();
  const onClick = (p: any, i: number) => {
    if (p.state === 'not-start') {
      return;
    }
    document
      .querySelectorAll('[data-paragraph]')
      [i]?.scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <div className="paragraphs">
      {paragraphs.map((p, i) => (
        <div
          key={i}
          onClick={() => onClick(p, i)}
          className={`paragraph ${p.state} ${
            i === activeParagraph ? 'active' : ''
          }`}
        >
          <div className="header">{p.header}</div>
          <div className="title">{p.title}</div>
          <div className="state">
            <div className={p.state} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Paragraphs;
